import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigStateService } from '@abp/ng.core';
import { OAuthService } from 'angular-oauth2-oidc';
import { firstValueFrom } from 'rxjs';
import { Store } from '@ngxs/store';
import { GetPageLayout } from '../app.actions';

@Component({
    selector: 'app-callback',
    template: `<p>Signing you in...</p>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CallbackComponent implements OnInit {
  constructor(
    private oAuthService: OAuthService,
    private configState: ConfigStateService,
    private router: Router,
    private store: Store,
  ) {}

  async ngOnInit() {
    const callbackStartedAt = performance.now();

    try {
      console.info('[Auth] Processing authorization code callback');

      if (!this.oAuthService.hasValidAccessToken()) {
        const tokenExchangeStartedAt = performance.now();
        await this.oAuthService.tryLogin();
        console.info('[Auth] Authorization code exchange completed', {
          elapsedMs: Math.round(performance.now() - tokenExchangeStartedAt),
        });
      }

      if (!this.oAuthService.hasValidAccessToken()) {
        throw new Error('Authorization code callback completed without a valid access token.');
      }

      const appStateStartedAt = performance.now();
      await firstValueFrom(this.configState.refreshAppState());
      console.info('[Auth] Application state refresh completed', {
        elapsedMs: Math.round(performance.now() - appStateStartedAt),
      });

      // AppComponent loaded the layout before sign-in finished (no user yet); load it for the signed-in user.
      this.store.dispatch(new GetPageLayout());

      const returnUrl = this.oAuthService.state
        ? decodeURIComponent(this.oAuthService.state)
        : '/';

      console.info('[Auth] Authorization code callback succeeded', {
        returnUrl,
        hasRefreshToken: Boolean(this.oAuthService.getRefreshToken()),
        totalElapsedMs: Math.round(performance.now() - callbackStartedAt),
      });

      await this.router.navigateByUrl(returnUrl || '/');
    } catch (error) {
      console.error('[Auth] Authorization code callback failed', error);

      const tenantName = localStorage.getItem('__tenant');
      await this.router.navigate(['/account/login'], {
        queryParams: tenantName ? { __tenant: tenantName } : undefined,
      });
    }
  }
}
